import { render, staticRenderFns } from "./ImportDynamicTagsModal.vue?vue&type=template&id=0a6a3d2c&scoped=true"
import script from "./ImportDynamicTagsModal.vue?vue&type=script&lang=js"
export * from "./ImportDynamicTagsModal.vue?vue&type=script&lang=js"
import style0 from "./ImportDynamicTagsModal.vue?vue&type=style&index=0&id=0a6a3d2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a6a3d2c",
  null
  
)

export default component.exports